import { useAuth } from '@/auth/AuthProvider';

// Self-serve provisioning switch for the "heavy" cloud services — Cloud Compute,
// Managed Kubernetes, Object Storage and Multi-CDN. When this is off, their
// activation CTA opens a "Talk to an expert" contact-sales dialog instead of
// provisioning the service directly. The one-click activation code stays wired
// behind this flag (nothing is deleted) so it can be re-enabled by flipping it.
export const SELF_SERVE_ACTIVATION = false;

/**
 * Runtime self-serve activation gate. Direct customers follow the global switch
 * above (currently contact-sales only), but an internal DataCentral staff member
 * impersonating the customer may provision on their behalf — so activation is
 * enabled while impersonating regardless of the global switch.
 */
export function useSelfServeActivation(): boolean {
  const { isImpersonating } = useAuth();
  return SELF_SERVE_ACTIVATION || isImpersonating;
}
